// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__Api from "../../../core/Api.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function Outsourcing(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const country = Buhta_landing__Route.getCountry(undefined);
  const countryStr = Buhta_models__Locale.toCountryString(country);
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const dispatchContent = match[1];
  const outsourcings = match[0].outsourcings;
  let outsourcing;
  try {
    outsourcing = Stdlib__List.hd(outsourcings);
  }
  catch (exn){
    outsourcing = {
      subtitle: "",
      note: "",
      country: ""
    };
  }
  React.useEffect((function () {
    const __x = $$Promise.all({
      hd: Buhta_landing__Api.outsourcing(countryStr),
      tl: /* [] */ 0
    });
    $$Promise.get(__x, (function (respList) {
      Stdlib__List.iter((function (res) {
        Buhta_landing__Api.handleResponse(res, dispatchContent, undefined);
      }), respList);
    }));
  }), [countryStr]);
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h1", {
            children: "Аутсорсинг бухгалтерия",
            className: "h3 lg:h1 lg:justify-center lg:w-252 text-center lg:text-left lg:flex lg:m-auto px-6 sm:px-48 lg:px-0 text-error-variant"
          }),
          JsxRuntime.jsx("h5", {
            children: outsourcing.subtitle,
            className: "paragraph-large lg:h5 text-center lg:justify-center lg:w-252 lg:flex lg:m-auto mt-4 lg:mt-6 px-6 sm:px-48 lg:px-0 text-error-variant"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("img", {
              className: "lg:h-100 lg:w-252",
              alt: "outsourcing",
              src: StaticAsset.src("/static/images/outsourcing-banner.svg")
            }),
            className: "lg:flex lg:m-auto mt-8 lg:mt-16 px-6 sm:px-48 lg:px-0 lg:w-252"
          }),
          JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
            classes: {
              hd: "flex m-auto mt-8 lg:mt-16",
              tl: /* [] */ 0
            },
            label: "Оставить заявку",
            onClick: (function (param) {
              Buhta_landing__EventHandlers.scrollToFooter(deviceType);
            })
          })
        ],
        className: "bg-black-landing py-16 lg:py-40"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Зачем нужен аутсорсинг",
            className: "h4 lg:h3 text-black-landing"
          }),
          JsxRuntime.jsx("p", {
            children: "С вас снимаются вопросы по подбору бухгалтера, обустройство места его работы, различные вопросы бытового характера. Вы просто занимаетесь своим делом.",
            className: "paragraph-large lg:h-light text-black-landing mt-2"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mr-2 shrink-0",
                src: StaticAsset.src("/static/icons/check-green.svg")
              }),
              JsxRuntime.jsx("p", {
                children: "Экономятся деньги на офис и компьютер",
                className: "paragraph lg:paragraph-large text-black-landing"
              })
            ],
            className: "flex mt-6 lg:mt-10"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mr-2 shrink-0",
                src: StaticAsset.src("/static/icons/check-green.svg")
              }),
              JsxRuntime.jsx("p", {
                children: "Решает проблему недоступности бухгалтера",
                className: "paragraph lg:paragraph-large text-black-landing"
              })
            ],
            className: "flex mt-4"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mr-2 shrink-0",
                src: StaticAsset.src("/static/icons/check-green.svg")
              }),
              JsxRuntime.jsx("p", {
                children: "Сокращает время на организационные вопросы",
                className: "paragraph lg:paragraph-large text-black-landing"
              })
            ],
            className: "flex mt-4"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mr-2 shrink-0",
                src: StaticAsset.src("/static/icons/check-green.svg")
              }),
              JsxRuntime.jsx("p", {
                children: "Снижается налоговая нагрузка на содержание сотрудника в штате",
                className: "paragraph lg:paragraph-large text-black-landing"
              })
            ],
            className: "flex mt-4"
          }),
          JsxRuntime.jsx("p", {
            children: outsourcing.note,
            className: "paragraph-small text-gray-light-landing mt-6 lg:mt-10"
          })
        ],
        className: "flex m-auto lg:w-252 pt-10 lg:pt-40 flex-col px-6 sm:px-48 lg:px-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: "«Бухта позволяет нам сократить расходы на бухгалтерию, вместе с тем предоставляя хорошее качество обслуживания.»",
            className: "paragraph-large text-center text-black-landing"
          }),
          JsxRuntime.jsx("p", {
            children: "Алена Ткаченко ･ Nommi",
            className: "paragraph-small text-center text-black-landing mt-2 lg:mt-4"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("img", {
              className: "h-6",
              src: StaticAsset.src("/static/icons/nommi.svg")
            }),
            className: "flex m-auto mt-6 lg:mt-8"
          })
        ],
        className: "flex m-auto mt-10 lg:mt-40 lg:w-252 lg:rounded-sm flex-col py-10 px-6 lg:py-16 sm:px-48 lg:px-20 bg-warning"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Как это работает",
            className: "h4 lg:h3 lg:w-252 lg:flex lg:m-auto mt-10 lg:mt-40 text-black-landing"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Тысячи компаний доверили нам вести их учет. Мы помогаем не просто привести дела в порядок, а значительно улучшить их за счет бесперебойности работы и скорости реакции. Множество наших клиентов начав с простого аутсорсинга выросли в большие компании для которых мы делаем индивидуальные решения.",
                className: "paragraph lg:w-122 text-gray-landing"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("p", {
                    children: [
                      JsxRuntime.jsx("img", {
                        className: "mr-2.5 mt-1.5 shrink-0",
                        src: StaticAsset.src("/static/icons/number-one-check-large.svg")
                      }),
                      JsxRuntime.jsx("span", {
                        children: "Работая с Бухтой вы просто даете задания бухгалтеру",
                        className: "w-110"
                      })
                    ],
                    className: "paragraph lg:paragraph-large text-black-landing mt-4 lg:mt-0 flex items-center"
                  }),
                  JsxRuntime.jsxs("p", {
                    children: [
                      JsxRuntime.jsx("img", {
                        className: "mr-2.5 mt-1.5 shrink-0",
                        src: StaticAsset.src("/static/icons/number-two-check-large.svg")
                      }),
                      JsxRuntime.jsx("span", {
                        children: "Получаете от него данные о вашем предприятии, необходимости оплаты налогов и их расчет",
                        className: "w-110"
                      })
                    ],
                    className: "paragraph lg:paragraph-large text-black-landing mt-4 flex items-center"
                  }),
                  JsxRuntime.jsxs("p", {
                    children: [
                      JsxRuntime.jsx("img", {
                        className: "mr-2.5 mt-1.5 shrink-0",
                        src: StaticAsset.src("/static/icons/number-three-check-large.svg")
                      }),
                      JsxRuntime.jsx("span", {
                        children: "Бухта сдает за вас отчеты, проводит платежи, подготавливает документы",
                        className: "w-110"
                      })
                    ],
                    className: "paragraph lg:paragraph-large text-black-landing mt-4 flex items-center"
                  })
                ],
                className: "lg:w-122"
              })
            ],
            className: "lg:flex lg:m-auto mt-6 lg:mt-10 lg:justify-between lg:w-252"
          }),
          JsxRuntime.jsx("p", {
            children: outsourcing.note,
            className: "paragraph-small lg:w-252 lg:flex lg:mx-auto mt-10 text-gray-light-landing"
          })
        ],
        className: "px-6 sm:px-48"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/guard-circled.svg")
          }),
          JsxRuntime.jsx("h3", {
            children: "100% гарантия на наши услуги",
            className: "h4 lg:h3 text-center text-black-landing mt-4"
          }),
          JsxRuntime.jsx("p", {
            children: outsourcing.note,
            className: "paragraph lg:h-light text-center text-gray-landing mt-2 lg:w-180"
          }),
          JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
            classes: {
              hd: "flex m-auto mt-6 lg:mt-10",
              tl: /* [] */ 0
            },
            label: "Оставить заявку",
            onClick: (function (param) {
              Buhta_landing__EventHandlers.scrollToFooter(deviceType);
            })
          })
        ],
        className: "flex flex-col items-center m-auto mt-10 lg:mt-40 lg:w-252 pt-8 lg:pt-18 pb-10 lg:pb-20 lg:rounded-sm px-6 sm:px-48 lg:px-0 bg-bg"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Преимущества",
            className: "h4 lg:h3 text-black-landing"
          }),
          JsxRuntime.jsxs("p", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mr-4.5 -mt-1.5 shrink-0",
                src: StaticAsset.src("/static/icons/number-one-check-large.svg")
              }),
              JsxRuntime.jsx("span", {
                children: "Вам не нужно заниматься подбором кадров на должность бухгалтера",
                className: "w-134"
              })
            ],
            className: "paragraph lg:paragraph-large text-black-landing mt-6 lg:mt-10 flex items-center"
          }),
          JsxRuntime.jsxs("p", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mr-4.5 -mt-1.5 shrink-0",
                src: StaticAsset.src("/static/icons/number-two-check-large.svg")
              }),
              JsxRuntime.jsx("span", {
                children: "Отсутствие затрат на организацию рабочего места для бухгалтера",
                className: "w-134"
              })
            ],
            className: "paragraph lg:paragraph-large text-black-landing mt-4 flex items-center"
          }),
          JsxRuntime.jsxs("p", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mr-4.5 -mt-1.5 shrink-0",
                src: StaticAsset.src("/static/icons/number-three-check-large.svg")
              }),
              JsxRuntime.jsx("span", {
                children: "Отсутствие вопроса замещения бухгалтера",
                className: "w-134"
              })
            ],
            className: "paragraph lg:paragraph-large text-black-landing mt-4 flex items-center"
          }),
          JsxRuntime.jsxs("p", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mr-4.5 -mt-1.5 shrink-0",
                src: StaticAsset.src("/static/icons/number-four-check-large.svg")
              }),
              JsxRuntime.jsx("span", {
                children: "Нет затрат по налогам и заработной плате бухгалтера",
                className: "w-134"
              })
            ],
            className: "paragraph lg:paragraph-large text-black-landing mt-4 flex items-center"
          }),
          JsxRuntime.jsxs("p", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mr-4.5 -mt-1.5 shrink-0",
                src: StaticAsset.src("/static/icons/number-five-check-large.svg")
              }),
              JsxRuntime.jsx("span", {
                children: "Ответственность за правильную сдачу отчетов и ведение бухгалтерии берет на себя аутсорсинговая компания",
                className: "w-134"
              })
            ],
            className: "paragraph lg:paragraph-large text-black-landing mt-4 flex items-center"
          }),
          JsxRuntime.jsxs("p", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mr-4.5 -mt-1.5 shrink-0",
                src: StaticAsset.src("/static/icons/number-six-check-large.svg")
              }),
              JsxRuntime.jsx("span", {
                children: "Работа в тикетовой системе, в которой удобно найти историю обращений",
                className: "w-134"
              })
            ],
            className: "paragraph lg:paragraph-large text-black-landing mt-4 flex items-center"
          })
        ],
        className: "flex m-auto flex-col py-10 lg:py-20 px-6 sm:px-48 lg:px-0 lg:w-148"
      })
    ]
  });
}

const make = Outsourcing;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
